<template>
<!-- 讨论 -->
    <div v-if="body_show">
        <div class="html" v-html="data.content"></div>
    </div>
</template>

<script>
import { getDiscussion } from '@/api/course2'
import { shareCon } from "@/utils/wxconfig"
export default {
    data() {
        return{
            body_show:false,
            data:{}
        }
    },
    methods:{
        pullData(){
            getDiscussion({
                id:this.$route.query.table_id
            }).then((data)=>{
                document.title = data.info.name;
                this.data = data.info;
                this.body_show = true;
            });
        }
    },
    created(){
        this.pullData();
        shareCon("course2",this);
    }
}
</script>

<style lang="scss" scope>
    .html{
        background-color: #fff;
        width: 100%;
        img{
            width: 100%;
        }
    }
</style>